import React from 'react';
import ModuleImagePage from '../shared/ModuleImagePage.jsx';

const Logistics = () => <ModuleImagePage moduleKey="logistics" />;

export default Logistics;
